import { FormGroup } from '@angular/forms'
import { Observable } from 'rxjs/Rx'

import { MessageService } from '../../core/services'
import { IFormOption } from '../../forms/services'

export class FormHelper {
  private _defaultOption: string = '-- Select an Option --'

  public get defaultOptionText() {
    return this._defaultOption
  }

  constructor(private _messageService: MessageService) {}

  public addDefaultOption(options: IFormOption[], defaultOptionName?: string): IFormOption[] {
    options.unshift({
      value: '',
      label: defaultOptionName || this._defaultOption
    })
    return options
  }

  public formProcessingMessenger<T>(
    formGroup: FormGroup,
    processingObservable: Observable<T>,
    messages: { success: string, error: string }
  ): Observable<T> {

    const emitMessage = (msg: string, category: 'Error'|'Success') => {
      const message = this._messageService[`create${category}Message`](msg)
      this._messageService.send(message)
    }
    const onError = (err) => {
      emitMessage(messages.error, 'Error')
    }
    const onSuccess = () => {
      emitMessage(messages.success, 'Success')
      formGroup.enable()
    }

    return Observable.of(null)
      .map(() => { formGroup.disable(); return processingObservable })
      .flatMap((model) => model)
      .do((next) => {}, onError, onSuccess)
  }

}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/form/form.helper.ts